<mat-spinner [diameter]="size"></mat-spinner><span *ngIf="text" class="progress-text">{{ text }}</span>
